export const MenuItems = [
  {
    title: "Home",
    url: "/welcome",
    cName: "nav-links",
  },
  {
    title: "Profile",
    url: "/profile",
    cName: "nav-links",
  },
  {
    title: "Add Service",
    url: "/service",
    cName: "nav-links",
  },
  {
    title: "Service Details",
    url: "/details",
    cName: "nav-links",
  },
  {
    title: "Log out",
    url: "/logout",
    cName: "btn-danger nav-links",
  },
];
